var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticStyle:{"width":"100%"}},[_c('a-tabs',{attrs:{"default-active-key":"1"},on:{"change":_vm.callback}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"申请"}},[_c('Toapplyfor')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"立项","force-render":""}},[_c('project')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }